import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20theater%20atmosphere%20with%20deep%20crimson%20and%20gold%20curtains%2C%20soft%20spotlight%20beams%20cutting%20through%20subtle%20atmospheric%20haze%2C%20luxurious%20velvet%20textures%2C%20elegant%20warm%20lighting%2C%20no%20people%2C%20clean%20theatrical%20composition%2C%20rich%20dark%20background%20with%20gentle%20bokeh&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="91电影视频 - 高清影视平台"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/65"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1300px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 text-accent-200 text-sm font-medium tracking-wide border border-accent-500/30">
              {heroData.tag}
            </span>

            <h1 className="mt-6 text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-background-50 leading-tight">
              {heroData.h1}
            </h1>

            <p className="mt-4 text-lg md:text-xl text-background-200 font-medium">
              {heroData.slogan}
            </p>

            <p className="mt-6 text-sm md:text-base text-background-300 leading-relaxed max-w-[620px] lg:max-w-none">
              {heroData.intro}
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-background-400 mt-0.5">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <button
                onClick={() => handleClick(heroData.ctaPrimary.href)}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-md hover:bg-primary-600 transition-colors text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill mr-2"></i>
                {heroData.ctaPrimary.text}
              </button>
              <button
                onClick={() => handleClick(heroData.ctaSecondary.href)}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 text-background-50 font-medium rounded-md border border-background-50/30 hover:bg-background-50/25 transition-colors text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-grid-line mr-2"></i>
                {heroData.ctaSecondary.text}
              </button>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative aspect-[4/5] rounded-lg overflow-hidden shadow-2xl">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20overlapping%20movie%20frames%20in%20warm%20golden%20and%20deep%20crimson%20tones%2C%20classic%20film%20reel%20and%20modern%20digital%20elements%20blended%2C%20dramatic%20lighting%2C%20artistic%20movie%20poster%20style%2C%20no%20text%2C%20clean%20dark%20background%2C%20professional%20cinematic%20composition&width=800&height=1000&seq=hero-visual-2026&orientation=portrait"
                alt="91电影视频 影视合集视觉"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <div className="flex-1 h-1.5 bg-background-50/30 rounded-full overflow-hidden">
                  <div className="h-full w-[65%] bg-primary-400 rounded-full"></div>
                </div>
                <span className="text-xs text-background-100 font-medium whitespace-nowrap">65%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}